import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";
import { DetectLayoutButton } from "../DetectLayoutButton";
import type { LayoutDetectionStripProps } from "./types";

// Under the layout view tabs: a running detection for everyone, the button to start one for editors.
export const LayoutDetectionStrip = ({
  layoutDetection,
  canEdit,
}: LayoutDetectionStripProps) => {
  const { t } = useTranslation();

  if (!layoutDetection.isAvailable || layoutDetection.isDone) return null;

  if (layoutDetection.isRunning) {
    return (
      <div className="mt-3 flex items-center gap-2 rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-800">
        <Loader2 size={14} className="animate-spin shrink-0" />
        {t("smartSurveyor.layoutDetection.inProgress")}
      </div>
    );
  }

  if (!canEdit) return null;

  return (
    <div className="mt-3">
      <DetectLayoutButton onDetect={layoutDetection.detect} />
    </div>
  );
};
